import React from 'react'

export function IconChevronRightSmallSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 5.5 8.5" fill="none">
      <path
        d="M0.75001 0.75001L4.75001 4.25001L0.75001 7.75001"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
